import type { MbcAdminErrorResponse } from "@nlc/shared-types";

import { MBC_AI_API_URL } from "@/features/request/mbc-review/config";

const ADMIN_URL = `${MBC_AI_API_URL}/mbc/admin`;

export async function adminRequest<T>(
  path: string,
  method = "GET",
  body?: unknown,
): Promise<T> {
  const response = await fetch(`${ADMIN_URL}${path}`, {
    body: body === undefined ? undefined : JSON.stringify(body),
    headers:
      body === undefined ? undefined : { "Content-Type": "application/json" },
    method,
  });

  if (!response.ok) {
    const error = (await response
      .json()
      .catch(() => null)) as MbcAdminErrorResponse | null;

    throw new Error(
      [
        error?.error ?? `HTTP ${response.status}`,
        ...(error?.details ?? []),
      ].join("\n"),
    );
  }

  return (await response.json()) as T;
}
